module.exports = __webpack_public_path__ + "18ffacba0aee1d3a69d6b69932bde3d0.png";